<template>
  <div v-if="isAdminRole">
    <div class="fab-title">{{$t(`FAB_TITLES.${getFabLink.title}`)}}</div>
    <div v-if="getFabLink">
      <router-link v-if="getFabLink.type === 'url'" :to="getFabLink.url">
        <div class="fab-circle bg-secondary" v-html="getFabLink.icon"></div>
      </router-link>
      <div v-else>
        <b-button v-on:click="download(routeName)" class="fab-circle bg-secondary" v-html="getFabLink.icon">
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    fabList: Object,
    routeName: String
  },
  computed: {
    ...mapGetters(['isAdminRole']),
    getFabLink () {
      return this.fabList[this.routeName]
    }
  },
  methods: {
    download: function (routeName) {
      // Event emission happens from here, corresponding events are caught on respective components.
      if (routeName === 'Reports') {
        this.$root.$emit('exportReports', true)
      } else if (routeName === 'Log History') {
        this.$root.$emit('exportLogs', true)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Fab.vue